

/*
FrFr FRIENDLY FRAMEWORK
frfr-async-utils
Version ID: 1a 2024-11-28r1
by 
// Please describe here if you customized this file
*/


const async_utils = {};

async_utils.pause = (ms) => {
  // univerzalna utility koja pravi Promise i resolcuje ga sa zelejnom vrednoscu nakon zeljenog broja milisekundi
  if (ms > 0) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms)
    });
  } else { // resolve without delay
    return true;
  }
};

async_utils.promise_resolve_after = (x, ms) => {
  // univerzalna utility koja pravi Promise i resolcuje ga sa zelejnom vrednoscu nakon zeljenog broja milisekundi
  let _ms = 0;
  if (ms > 0) {
    _ms = ms;
  }
  return new Promise(resolve => {
    setTimeout(() => { resolve(x) }, _ms);
  });
}

async_utils.promise_reject_after = (x, ms) => {
  // univerzalna utility koja pravi Promise i reject-uje ga nakon zeljenog broja milisekundi
  let _ms = 0;
  if (ms > 0) {
    _ms = ms;
  }
  return new Promise((resolve, reject) => {
    setTimeout(() => { reject(x) }, _ms);
  });
}

async_utils.old_school_run_async = function (f) {
  // old school run async
  // primer asinhrone funkcije u starom javascriptu
  setTimeout(function () {
    if (typeof f === 'function') {
      f();
    }
  }, 0);
};

async_utils.asyncForEach = async (_arr, async_func) => {
  let arr = [..._arr];
  // TODO...
  // https://thecodebarbarian.com/for-vs-for-each-vs-for-in-vs-for-of-in-javascript.html
  // resenje 1 i 2 serijski ili paralelno https://stackoverflow.com/questions/37576685/using-async-await-with-a-foreach-loop
  /*
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
  */
  /*
  for (const file of files) {
    const contents = await fs.readFile(file, 'utf8');
    console.log(contents);
  }
  */

  /*
  for (const a of arr) {
    const aiteration = await async_func(a);
    // TODO: razlika u odnosu na klasican forEach je sto pravi foreach ima index kao drugi argument a ovaj jos uvek nema
  }
  */

  // https://thecodebarbarian.com/for-vs-for-each-vs-for-in-vs-for-of-in-javascript.html
  for (const [i, v] of arr.entries()) {
    console.log(i, v); // Prints "0 a", "1 b", "2 c"
    const aiteration = await async_func(v, i); // value, index salje kao argument callbacku isto kao foreEach sto radi
  }

  // resenje 3 https://2ality.com/2016/10/asynchronous-iteration.html
  /*
  try {
    for await (const x of arr) {
      console.log(x);
    }
  } catch (e) {
    console.error(e);
    // Error: Problem!
  }
  */
  return;
};

export { async_utils };
// exports.async_utils = async_utils; // Node.js named export